import { useEffect, useState } from 'react';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';
import { useBannerService } from '@bingads-webui/inline-copilot';
import { useEventLog } from '@bingads-webui-campaign-react/copilot-common';

export function useCopilotForResponsiveSearchAd({
  permissions,
  postAssetEventLog,
  serverContext,
}) {
  const [isCopilotEnabled, setIsCopilotEnabled] = useState();
  const { send: sendCopilotBannerNotification } = useBannerService();
  const eventLog = useEventLog(postAssetEventLog);

  useEffect(() => {
    isCopilotRegionRestricted({
      feature: 'Recommendations',
      permissions,
      serverContext,
    }).then(isRestricted => setIsCopilotEnabled(!isRestricted));
  }, [permissions, serverContext]);

  return {
    eventLog,
    isCopilotEnabled,
    sendCopilotBannerNotification,
  };
}
